import { Flex } from "antd";
import { XProvider, ThoughtChain } from "@ant-design/x";
import { createStyles } from "antd-style";
import type { ReactNode } from "react";

import ContainerBg1 from "@/assets/opsmate/bg1.png";
import ContainerBg2 from "@/assets/opsmate/bg2.png";
import { useOpsMateContext } from "@/contexts/useOpsMateContext";
import ConversationsMenus from "./ConversationsMenus";

const useStyles = createStyles(() => ({
  container: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "left top",
    paddingInlineStart: 18,
    borderRadius: 12,
    overflow: "hidden",
  },
  menuCollapsedBg: {
    backgroundImage: `url(${ContainerBg2})`,
  },
  menuNotCollapsedBg: {
    backgroundImage: `url(${ContainerBg1})`,
  },
}));

interface OpsMateRouteShellProps {
  children: ReactNode;
}

export default function OpsMateRouteShell({ children }: OpsMateRouteShellProps) {
  const { styles } = useStyles();
  const { pageHeight, collapsed: menuCollapsed } = useOpsMateContext();

  return (
    <div
      style={{
        padding: 10,
        height: "calc(100vh - 56px)",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <XProvider
        theme={{
          token: { colorPrimary: "#830050", borderRadiusLG: 4 },
          components: { Conversations: { borderRadius: 4 } },
        }}
      >
        <Flex style={{ height: pageHeight, backgroundSize: "contain" }} gap={12}>
          <ConversationsMenus />
          <Flex
            className={[
              styles.container,
              menuCollapsed ? styles.menuCollapsedBg : styles.menuNotCollapsedBg,
            ].join(" ")}
            flex={1}
            style={{ minWidth: 0, paddingInlineStart: 0 }}
          >
            <div style={{ flex: 1, minWidth: 0, minHeight: 0, overflow: "auto" }}>{children}</div>
          </Flex>
        </Flex>
        <ThoughtChain />
      </XProvider>
    </div>
  );
}
